import React from "react";
import { Box, Tooltip, Typography } from "@material-ui/core";
import { get } from "lodash";
import UserProfileWidget from "Components/widgets/UserProfileWidget";
import { useStyles } from "../styles";

const UserName = (colProps) => {
  const classes = useStyles();
  return (
    <td
      onClick={() => colProps?.onRowClick && colProps.onRowClick(colProps)}
      data-testid="onRowClick"
    >
      <Tooltip
        title={`${get(colProps, "dataItem.name", "")}  ${
          colProps?.showPendingTab &&
          colProps.dataItem?.userStatus === "PENDING"
            ? " (Pending) "
            : ""
        }`}
      >
        <Box
          display="flex"
          alignItems="center"
          className={colProps?.onRowClick ? "cursor-pointer" : null}
        >
          <UserProfileWidget
            firstName={get(colProps, "dataItem.firstName", "")}
            lastName={get(colProps, "dataItem.lastName", "")}
            url={get(colProps, "dataItem.profileImage", "")}
            status={colProps?.dataItem?.userStatus}
          />
          {/* <span className="truncate-txt">
            {`${get(colProps, "dataItem.name", "")}  ${
              colProps.dataItem?.userStatus === "PENDING"
                ? " (Pending) "
                : ""
            }`}
          </span> */}
          <div className={classes.userDetails}>
            <span className="truncate-txt d-block">
              {`${get(colProps, "dataItem.name", "")}`}
            </span>
            <span className="truncate-txt d-block font-12 f-light-gray">
              {` ${
                colProps?.showPendingTab &&
                colProps.dataItem?.userStatus === "PENDING"
                  ? " (Pending) "
                  : ""
              }`}
            </span>
          </div>
        </Box>
      </Tooltip>
    </td>
  );
};

export default UserName;
